import { useEffect, useState } from 'react';
import { useQuery } from 'urql';
import { useFragment } from '@frontend/gql/social';
import { Period } from '@frontend/gql/social/graphql';
import { insightsByClientId, socialAdsAnalyticsFragment } from '../graphql';

interface UseAdsQueryDataProps {
  clientId?: string;
  currentIntervalRange: {
    startDate: string;
    endDate: string;
    precision: Period;
  };
  previousIntervalRange: {
    startDate: string;
    endDate: string;
  };
  startDate: string;
  endDate: string;
}

export const useAdsQueryData = ({
  clientId,
  currentIntervalRange,
  previousIntervalRange,
  startDate,
  endDate,
}: UseAdsQueryDataProps) => {
  const [refetching, setRefetching] = useState(false);

  const [{ data, fetching, error }, refetch] = useQuery({
    query: insightsByClientId,
    variables: {
      clientId: clientId || '',
      currentIntervalRange,
      previousIntervalRange,
    },
    pause: !clientId || !startDate || !endDate,
  });

  useEffect(() => {
    if (!fetching) {
      setRefetching(false);
    }
  }, [fetching]);

  const socialAdsAnalyticsData = useFragment(socialAdsAnalyticsFragment, data);

  // Extract and organize the data
  const processedData = {
    metaAdAccounts: socialAdsAnalyticsData?.client?.metaAdAccounts || [],
    currentInterval: socialAdsAnalyticsData?.client?.currentInterval,
    currentIntervalsIntervalInsights: socialAdsAnalyticsData?.client?.currentIntervalsIntervalInsights,
    currentIntervalsIntervalInsightsNotAspireSourced:
      socialAdsAnalyticsData?.client?.currentIntervalsIntervalInsightsNotAspireSourced,
    previousInterval: socialAdsAnalyticsData?.client?.previousInterval,
    currentIntervalNotAspireSourced: socialAdsAnalyticsData?.client?.currentIntervalNotAspireSourced,
    previousIntervalNotAspireSourced: socialAdsAnalyticsData?.client?.previousIntervalNotAspireSourced,
  };

  const handleRefetch = () => {
    setRefetching(true);
    refetch({ requestPolicy: 'network-only' });
  };

  return {
    data,
    fetching,
    error,
    refetching,
    processedData,
    handleRefetch,
  };
};
